<template>
  <div>
    <slot name="botao-ativador" :ativador="mudarEstadoDialog">
      <v-btn
        color="#A51B32"
        dark small
        @click="mudarEstadoDialog"
      >
        <v-icon left>mdi-plus</v-icon>
        novo grupo de análise
      </v-btn>
    </slot>

    <SysDialog
      v-model="dialog_ativo"
      contentClass="b-radius-15px"
      largura="600"
      ocultar_botao_fechar
    >
      <template #titulo>
        <v-btn icon class="ml-n2 mr-3" @click="mudarEstadoDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <div class="ml-3">
          <p class="ma-0">Novo grupo de análise</p>
          <p class="ma-0 mt-n2 font-12 font-weight-regular">Os fornecedores selecionados serão agrupados em uma mesma análise</p>
        </div>
      </template>

      <template #default>
        <v-text-field
          v-model="grupo_analise.nome"
          label="Nome"
          outlined
          single-line
          hide-details
          autofocus
          :error-messages="nome_grupo"
          @input="$v.grupo_analise.nome.$touch()"
          @keydown.enter="criarOuEditar()"
        />

        <v-divider class="my-4"/>

        <SysFornecedorAutocomplete 
          v-model="fornecedores"
          label="Fornecedores"
          hint="Fornecedores selecionados"
          outlined
          single-line
          persistent-hint
          multiple
          @change="atualizarFornecedoresDoGrupo()"
        />

        <v-divider class="mt-4" v-if="grupo_analise_para_edicao.id" />

        <ListaFornecedoresDoGrupoAnalise
          v-if="grupo_analise_para_edicao.id"
          :id_grupo_analise="grupo_analise_para_edicao.id"
          :fornecedores_selecionados="fornecedores"
          class="mtn2" 
          @fornecedores="fornecedores = $event"
        />
      </template>

      <template #actions>
        <v-btn color="red" dark text class="mr-5" @click="comecarTempoParaDelecao">
          <template v-if="tempo_delecao > 0">
            <v-icon left>mdi-close</v-icon>
             {{`cancelar (${tempo_delecao})`}}
          </template>

          <template v-else-if="grupo_analise_para_edicao.id">
            <v-icon left>mdi-delete</v-icon>
            apagar
          </template>
        </v-btn>

        <v-btn text color="primary" @click="criarOuEditar">
          <v-icon left>mdi-cloud-check</v-icon>
          salvar
        </v-btn>
      </template>
    </SysDialog>
  </div>
</template>

<script>
import api from "@/api/api";
import SysDialog from "../../padraoDeLayout/SysDialog";
import { required } from "vuelidate/lib/validators";
import FornecedorAPI from "./../../../api/fornecedor.js";
import {arrayColumn, logout} from "./../../../helpers/index.js";
import ListaFornecedoresDoGrupoAnalise from "./ListaFornecedoresDoGrupoAnalise";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";

const UM_SEGUNDO = 1000;

export default {
  name: "CriarGrupoDeAnaliseDeCompras",
  components: {
    ListaFornecedoresDoGrupoAnalise, 
    SysDialog,
    SysFornecedorAutocomplete
  },
  model: {
    prop: "valor_do_modelo",
    event: "atualizar:valor_do_modelo"
  },
  props:  {
    valor_do_modelo: {
      type: Array,
      default: () => []
    },
    grupo_analise_para_edicao: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    fornecedores: [],
    dialog_ativo: false,
    tempo_delecao: null,
    timer_interval: null,
    grupo_analise: {
      nome: ""
    }
  }),
  validations: {
    grupo_analise: {
      nome: {required}
    }
  },
  computed: {
    fornecedores_selecionados: {
      get: function () {
        return this.valor_do_modelo;
      },
      set: function (novo_valor) {
        this.$emit("atualizar:valor_do_modelo", novo_valor);
      }
    },
    nome_grupo() {
      const errors = [];
      if (!this.$v.grupo_analise.nome.$dirty) return errors;
      !this.$v.grupo_analise.nome.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  watch: {
    valor_do_modelo() {
      this.fornecedores = this.valor_do_modelo.map(fornecedor => fornecedor.id);
    },
    dialog_ativo() {
      if (this.dialog_ativo) return;
      this.$v.$reset();
    },
    'grupo_analise.nome': {
      handler() {
        this.grupo_analise.nome = `${this.grupo_analise.nome || ''}`.toUpperCase();
      }
    }
  },
  methods: {
    atualizarFornecedoresDoGrupo() {
      if (!this.grupo_analise_para_edicao.id) return;

      const params = {
        fornecedores: this.fornecedores, 
        id_grupo_analise: this.grupo_analise_para_edicao.id
      };

      api.post("/fornecedores/grupo-analise/atualizar-fornecedores", params)
        .then(() => this.fornecedores = [])
        .catch(logout);
    },
    mudarEstadoDialog() {
      if (this.grupo_analise_para_edicao.id > 0) {
        this.grupo_analise.nome = this.grupo_analise_para_edicao.razao_social;
      }

      this.dialog_ativo = !this.dialog_ativo;
    },
    criarOuEditar() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      if (this.grupo_analise_para_edicao.id > 0) {
        this.editarGrupoAnalise();
      } else {
        this.salvarGrupoAnalise();
      }
    },
    salvarGrupoAnalise() {
      const parametros = {
        grupo: this.$store.getters["usuario/getGrupoCompras"],
        nome: this.grupo_analise.nome,
        fornecedores: arrayColumn(this.fornecedores_selecionados, "id")
      };

      this.$store.dispatch("loading/addRequisicao",
        FornecedorAPI.criarGrupoAnaliseCompra(parametros).then(this.sucessoResposta).catch(() => logout())
      );
    },
    editarGrupoAnalise() {
      const parametros = {
        id: this.grupo_analise_para_edicao.id,
        grupo: this.$store.getters["usuario/getGrupoCompras"],
        nome: this.grupo_analise.nome,
      };

      this.$store.dispatch("loading/addRequisicao",
        FornecedorAPI.editarGrupoAnaliseCompra(parametros).then(this.sucessoResposta).catch(() => logout())
      );
    },
    comecarTempoParaDelecao() {
      if (this.tempo_delecao > 0) {
        clearInterval(this.timer_interval);
        this.tempo_delecao = 0;
        return;
      }

      this.tempo_delecao = 3;

      const decrementa_os_segundos = () => {
        this.tempo_delecao--;

        if (this.tempo_delecao <= 0) {
          clearInterval(this.timer_interval);
          this.excluirGrupoAnalise();
        }
      };

      this.timer_interval = setInterval(decrementa_os_segundos, UM_SEGUNDO);
    },
    excluirGrupoAnalise() {
      const parametros = {
        id: this.grupo_analise_para_edicao.id,
        grupo: this.$store.getters["usuario/getGrupoCompras"]
      };

      this.$store.dispatch("loading/addRequisicao",
        FornecedorAPI.excluirGrupoAnaliseCompra(parametros).then(this.sucessoResposta).catch(() => logout())
      );
    },
    sucessoResposta(resposta) {
      localStorage.token = resposta.data.token;
      this.salvoComSucesso();
    },
    salvoComSucesso(){
      this.fornecedores_selecionados = [];
      this.grupo_analise.nome = "";
      this.mudarEstadoDialog();
      this.$emit("cadastro-com-sucesso", {});
    }
  }
}
</script>
